module.exports = __webpack_public_path__ + "static/media/41_A.56f554ba.png";